import LazyLoad from 'vanilla-lazyload/dist/lazyload.min';
import { productItemHover } from './product-item-hover';
import { popupVideo } from './popups';
import { customSelects } from './custom-select';
import { addToCart, updateCartGift, updateCart, ajaxCart } from './ajax-cart';
import { productSelectGlobal } from './product-select-global';

const $doc = $(document);
const $win = $(window);

// Change Variants/Images - Radio
$doc.on('change', '.js-radio-color-item input', function() {
  const $this = $(this);
  const idx = $this.data('index');
  const optionIdx = $this.data('option'); 
  const optionVal = $this.data('value');
  const $productItem = $this.closest('.js-product-item');
  const $target = $productItem.find('.product-item__image figure').eq(idx);
  const targetLink = $target.find('a').attr('href');
  const $detailsBtn = $('.js-product-item-details');
  const $form = $this.closest('form');

  $target
    .addClass('expanded')
    .siblings()
    .removeClass('expanded');

  if ($detailsBtn.length) {
    $detailsBtn.attr('href', targetLink)
  };

  $productItem.find(`.js-product-item-select option[data-option-${optionIdx}="${optionVal}"]`).prop('selected', 'selected');

  // Sold Out
  const $optionSelected = $productItem.find('.js-product-item-select option:selected');

  if ($optionSelected.is(':disabled')) {
    $form
      .addClass('form-product-small--sold-out')
      .removeClass('form-product-small--pre-order')
      .find('.js-product-item-btn')
      .attr('disabled', 'disabled');
  } else {
    $form
      .removeClass('form-product-small--sold-out')
      .find('.js-product-item-btn')
      .removeAttr('disabled');
  }

  // Price
  const price = $optionSelected.data('price');
  if ($form.find('.js-product-item-price').length) {
    $form.find('.js-product-item-price').html(price);
  };

  // Save
  const save = $optionSelected.data('save');
  if ($form.find('.js-product-item-save').length) {
    $form.find('.js-product-item-save').html(save);
  };
});

// Change Images - Hover
$doc
  .on('mouseenter', '.js-radio-color-item label', function() {
    const $this = $(this);

    productItemHover($this, true)
  })
  .on('mouseleave', '.js-radio-color-item label', function() {
    const $this = $(this);

    productItemHover($this, false)
  });

// Quick View - AJAX
$doc.on('click', '.js-product-item-view', function(e) {
  e.preventDefault();
  const $this = $(this);
  const btnHref = $this.attr('href');
  const $targetPopup = $($this.data('popup'));
  const className = $this.data('class');
  const formVariantId = $this.closest('form').find('.js-product-item-select option:selected').val();

  $.ajax({
    url: btnHref,
    success: function(data) {
      const $data = $(data)
      const $product = $data.find('.js-product').addClass('section-product--secondary').removeClass('section-product--primary');

      if ($targetPopup.find('.popup__content').length) {
        $targetPopup.find('.popup__content').html($product);
        $targetPopup.addClass(className);

        if ($data.find('.lazyload').length) {
          const myLazyLoad = new LazyLoad({
            elements_selector: '.lazyload'
          });
        };

        const $sliderProduct = $('.section-product--secondary').find('.js-slider-product');
        const $sliderThumbs = $('.section-product--secondary').find('.js-slider-thumbs');

        if ($sliderProduct.length) {
          $sliderProduct.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            fade: true,
            draggable: false,
            asNavFor: $sliderThumbs
          });
        };

        if($sliderThumbs.length) {
          $sliderThumbs.slick({
            asNavFor: $sliderProduct,
            focusOnSelect: true,
            infinite: true,
            autoplay: false,
            speed: 300,
            arrows: true,
            dots: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            draggable: false,
            touchMove: false,
            swipe: false,
            vertical: true
          });
        }

        const $selectGlobal = $('.js-select-global');
        productSelectGlobal($selectGlobal, formVariantId);

        const $checkedInput = $('.section-product--secondary').find('.js-radio-color input:checked');
        if ($checkedInput.length) {
          $checkedInput.trigger('change');
        };

        if ($('.section-product--secondary').find('.js-popup-video').length) {
          popupVideo();
        };

        if ($('.section-product--secondary').find('.js-select-custom select').length) {
          customSelects();
        };

        if($('.section-product--secondary').find('#personalize-vue').length > 0) {
          let $pzContainer = $('.section-product--secondary').find('#personalize-vue');
          let sku = $pzContainer.data('sku');

        }

      };
    }
  });
});

// Add To Cart - AJAX
$doc.on('click', '.js-form-product-small .js-product-item-btn', function(e) {
  e.preventDefault();
  const $form = $(this).closest('form');

  addToCart($form, true);
});



// WEBPACK FOOTER //
// ../assets/js/product-item.js